export default __webpack_public_path__ + "static/kids-25ded09ddaa0ff1e0b911e1cfdec7077.svg";